import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable, } from 'rxjs/Observable';
import { map, catchError } from "rxjs/operators";
import { throwError } from "rxjs";
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { HttpClient } from "@angular/common/http";
import { SharedFunctions } from '../../../../src/app/shared/shared.functions';
import { LocalStorageKeys } from '../../../../src/app/shared/model';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    constructor(
        private sharedFunctions: SharedFunctions,
        private datePipe: DatePipe,
        private router: Router,
        private _http: HttpClient
    ) {}
    
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // add authorization header with jwt token if available
        try
        {
            //debugger;
            if (this.sharedFunctions == null)
                this.sharedFunctions = new SharedFunctions(this.router, this.datePipe, this._http);

            let t = this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.Token);
            
            //URLs excluidas de adjuntar el token
            const excludedUrls = ['login', 'register', 'faqs-public', 'anonymous'];
            if (excludedUrls.some((url) => request.url.includes(url))) {
                return next.handle(request);
            }

            if (t != null && t.length > 0 && !excludedUrls.some((url) => request.url.includes(url))) {
                let tenant = this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.TenantId);
                // console.log("tenant:"+tenant);
                request = request.clone({
                    setHeaders: {
                        Authorization: `Bearer ${t}`,
                        TenantId: (tenant ?? "")
                    }
                });
            }
        }
        catch (err) {
            console.error(err);
        }

        return next.handle(request).pipe(
            map(this.handleSuccess),
            catchError(this.handleError)
        );
    }

    handleSuccess(event) {
        // console.log('event--->>>', event);

        if (this.sharedFunctions == null)
            this.sharedFunctions = new SharedFunctions(this.router, this.datePipe, this._http);

        if (event instanceof HttpResponse) {
            // console.log(event.status);
            
            if (event != null)
            {
                if (event.status === 200 || event.status === 204)
                {
                    var tt = event?.body?.UpdatedToken;
                    if (tt != null && tt?.length > 0)
                    {
                        this.sharedFunctions.setLocalStorageValue(LocalStorageKeys.Token, tt);
                        // console.log("token actualizado ok!");
                    }
                }
            }
        }
        return event;
    }

    handleError(err: HttpErrorResponse) {

        // console.log("Error en server ->>", err);

        if (this.sharedFunctions == null)
            this.sharedFunctions = new SharedFunctions(this.router, this.datePipe, this._http);

        if (err != null)
        {
            switch (err.status)
            {
                //Server caido
                case 0:
                    // return throwError("Ocurrió un error solicitando los datos al servidor");
                    break;

                //Usuario no logueado / Sesion expirada / Token vencido
                case 401:
                    this.sharedFunctions.clearLocalStorage();
                    // return throwError("Su sesión expiró. Por favor iniciela nuevamente");
                    break;
            
                default:
                    break;
            }
        }

        //Server sin respuesta conocida
        return throwError(err);
    }
}
